/* eslint-disable class-methods-use-this */
import Vue from 'vue';
import GstplnApp, { GstplnAppCategory } from '../app';

export default class UntillApp extends GstplnApp {
  constructor(vue: Vue) {
    super(vue, 'app.untill', {
      categories: [GstplnAppCategory.Pos],
      underPaywall: true,
      hasDarkIcon: true,
      configComponentImportFnc: () => import('@/components/apps/untill/SettingsDialog.vue'),
    });
  }
}
